import Track from "webPage/Track";

export default function handleConsultantsListBlocks() {
    let $consultantsSlider = $(".js-mobile-cards-slider");
    if ($consultantsSlider.length > 0) {
        $consultantsSlider.each(function () {
            new Track($(this), {
                classes: {
                    block: "slider",
                },
            });
        });
    }
}
